import { nanoId } from '@/helpers'
import Vue from 'vue'

const other = () => {
  return {
    type: '1',
    class: '0',
    description: null,
    amount: null
  }
}

export const SET_TYPE = (state, { key, value }) => {
  state._[key].type = value
}

export const SET_CLASS = (state, { key, value }) => {
  state._[key].class = value
}

export const SET_DESCRIPTION = (state, { key, value }) => {
  state._[key].description = value
}

export const SET_AMOUNT = (state, { key, value }) => {
  state._[key].amount = value
}

export const ADD = (state, payload) => {
  let key = nanoId(8)
  state.list.push(key)
  if (!payload) payload = other()
  Vue.set(state._, key, Object.assign({}, payload))
}

export const DELETE = (state, key) => {
  state.list = state.list.filter(k => k !== key)
  delete state._[key]
}
